import { Client_Environment_Config } from "./Client_Environment_Config_Type";

export const Client_Config_Production: Client_Environment_Config = {
    paypal_client_id: 'AUOqK-jtrho2JzxBFI_fTzW9wyu303ylU2fjZTsQlPf3CNKmZF5FquJ9Q5BruNd5oYx4RsVqg2yO7XPV',
}